const colors = {
  box: {
    selected: '#2B71F8',
    onomatopoeia: '#6eaa4b',
    correction: '#aa584b',
    default: '#000000',
    text: 'white'
  },
  note: '#5f6771'
}

const fontFamily = {
  primary: 'Inter'
}

export {
  colors,
  fontFamily
}